import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';
import FAQ from '../components/FAQ';
import { ArrowUpRight } from 'lucide-react';

const FAQPage = () => {
  return (
    <div className="font-body bg-paper text-[#1c1c1c]">
      <Navbar />
      <PageHeader
        eyebrow="Frequently Asked"
        title={<>Everything you need to <em className="italic">know</em></>}
        description="From eligibility to placements — quick answers to the most common questions about our EA course."
        breadcrumb="FAQ"
      />
      <FAQ />

      {/* Still have questions */}
      <section className="py-16 md:py-20 bg-paper-soft">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="font-serif-display text-[#143324] text-3xl md:text-4xl leading-tight mb-4">
            Still have <em className="italic">questions</em>?
          </h2>
          <p className="text-[#3d3d3d] font-body mb-8">Our academic counselors respond within 24 hours. Book a free 15-minute call.</p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link to="/contact" className="inline-flex items-center gap-2 btn-primary px-6 py-3 rounded-full text-sm font-body">
              Contact Us <ArrowUpRight size={16} />
            </Link>
            <a href="https://wa.me/917010492161" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 btn-outline px-6 py-3 rounded-full text-sm font-body">
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQPage;
